import { useContext } from "react";
import CarouselContext from "../CarouselContext";
const useCarouselApi = (carouselId) => {
  const carouselContext = useContext(CarouselContext);
  if (!carouselContext) {
    throw new Error("useCarouselApi hook needs to be used inside CarouselApiProvider.");
  }
  if (!carouselContext[carouselId]) {
    throw new Error(`CarouselContext does not contain anything for carousel id ${carouselId}`);
  }
  return carouselContext[carouselId].api;
};
export default useCarouselApi;
